import { IncentiveOfferOperation } from 'modules/incentivesMarket/types';

const hasNonEmptyString = (value?: string) => Boolean(value?.trim());

export const resolveOperationDocumentId = (
  ref?: string | { _id?: string }
): string | null => {
  if (!ref) return null;
  if (typeof ref === 'string') return ref.trim() || null;
  return ref._id?.trim() || null;
};

export const hasOperationSellerSignature = (
  operation: IncentiveOfferOperation
): boolean => hasNonEmptyString(operation.sellerSignature);

export const hasOperationPurchaseContract = (
  operation: IncentiveOfferOperation
): boolean =>
  Boolean(resolveOperationDocumentId(operation.incentivesMarketPurchaseContract));

export type DocsSummaryCount = {
  existing: number;
  total: number;
};

export const getSummaryBadgeClass = (
  existing: number,
  total: number
): 'badge-success' | 'badge-warning' =>
  existing === total ? 'badge-success' : 'badge-warning';

export const getOperationsPageDocsSummary = (
  operations: IncentiveOfferOperation[]
): { signatures: DocsSummaryCount; contracts: DocsSummaryCount } => {
  const total = operations.length;

  const signaturesExisting = operations.filter(hasOperationSellerSignature).length;
  const contractsExisting = operations.filter(hasOperationPurchaseContract).length;

  return {
    signatures: { existing: signaturesExisting, total },
    contracts: { existing: contractsExisting, total },
  };
};
